const globalURL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000/railway-booking-frontend' : 'https://korneef.github.io/railway-booking-frontend'
const backendURL = 'https://students.netoservices.ru/fe-diplom'
export { globalURL, backendURL }
